module.exports = __webpack_public_path__ + "images/errorImg-0ac5ea3d7029a2eb092d2e3d29094501.jpeg";